import { createRoot }    from '@wordpress/element';
import apiFetch          from '@wordpress/api-fetch';
import './store';
import { initWishlist }            from './utils/wishlist';
import ProductGrid       from './blocks/product-grid/components/ProductGrid';
import WishlistDrawer    from './blocks/product-grid/components/WishlistDrawer';
import WishlistInlineIcon from './blocks/product-grid/components/WishlistInlineIcon';
import QuickViewModal    from './blocks/product-grid/components/QuickViewModal';
import FiltersPanel      from './blocks/product-filters/components/FiltersPanel';
import ActiveFiltersList from './blocks/active-filters/components/ActiveFiltersList';
import ProductShowcase   from './blocks/product-showcase/components/ProductShowcase';
import './styles/frontend.scss';

// Ensure apiFetch always has a working nonce and root URL regardless of
// whether WordPress's automatic wp-api-fetch inline script ran correctly.
// This guards against full-page caching, JS optimisers that strip inline
// scripts, and other environments where the automatic setup is unreliable.
if ( window.mwsbData ) {
	apiFetch.use( apiFetch.createNonceMiddleware( window.mwsbData.nonce ) );
	apiFetch.use( apiFetch.createRootURLMiddleware( window.mwsbData.restRoot ) );
}

function mountBlock( selector, Component, getProps ) {
	const nodes = document.querySelectorAll( selector );
	nodes.forEach( ( node ) => {
		try {
			const raw   = node.dataset.attributes;
			const attrs = raw ? JSON.parse( raw ) : {};
			const props = getProps ? getProps( attrs, node ) : attrs;
			createRoot( node ).render( <Component { ...props } /> );
		} catch ( err ) {
			// silent — prevents one bad block from crashing the rest
		}
	} );
}

document.addEventListener( 'DOMContentLoaded', () => {
	initWishlist();

	const drawerRoot = document.createElement( 'div' );
	drawerRoot.id = 'mwsb-wishlist-drawer-root';
	document.body.appendChild( drawerRoot );
	createRoot( drawerRoot ).render( <WishlistDrawer /> );

	document.querySelectorAll( '.mwsb-wishlist-icon--inline' ).forEach( ( el ) => {
		createRoot( el ).render( <WishlistInlineIcon /> );
	} );

	const qvRoot = document.createElement( 'div' );
	qvRoot.id = 'mwsb-quick-view-root';
	document.body.appendChild( qvRoot );
	createRoot( qvRoot ).render( <QuickViewModal /> );

	mountBlock(
		'[data-block="mwsb/product-grid"]',
		ProductGrid,
		( attributes ) => ( { attributes, instanceId: attributes.instanceId } )
	);

	mountBlock(
		'[data-block="mwsb/product-filters"]',
		FiltersPanel,
		( attributes ) => ( { attributes } )
	);

	mountBlock(
		'[data-block="mwsb/active-filters"]',
		ActiveFiltersList,
		( attributes ) => ( { showClearAll: attributes.showClearAll } )
	);

	mountBlock(
		'[data-block="mwsb/product-showcase"]',
		ProductShowcase,
		( attributes ) => ( { attributes } )
	);
} );
